import { styled } from '@linaria/react';

import { SearchInput } from '~shared/ui/organisms/SearchInput';
import { MqTablet } from '~theme/media';

export const StyledSearchInput = styled(SearchInput)<{ shrinkable: boolean }>`
	width: ${({ shrinkable }) => (shrinkable ? 'auto' : '500px')};
	flex: 1;

	${MqTablet} {
		flex: unset;
	}
`;
